export enum Incoterm {
  EXW = "EXW",
  FCA = "FCA",
  FAS = "FAS",
  FOB = "FOB",
  CFR = "CFR",
  CIF = "CIF",
  CTP = "CTP",
  CIP = "CIP",
  DAT = "DAT",
  DAP = "DAP",
  DDP = "DDP",
}
